import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { ModificationTrackingForm } from 'core/forms';
import pick from 'lodash/pick';

import { Typo } from 'uikit/content';

import styles from '../styles/multiModificationTrackingForm.module.scss';

const MultiModificationTrackingForm = ({
  model = {},
  onCancel = () => {},
  onSubmit = async () => {},
  onUpdate = () => {},
  schemas = [],
}) =>
  schemas.map(({ schema, title }) => (
    <Fragment key={title}>
      <Typo className={styles.title} element="h2" variant="d01">
        {title}
      </Typo>
      <ModificationTrackingForm
        model={pick(model, Object.keys(schema))}
        modifiedClassName={styles.isModified}
        onCancelClick={onCancel}
        onFormLoad={onUpdate}
        onSaveClick={onSubmit}
        onFormUpdate={onUpdate}
        schema={schema}
      />
    </Fragment>
  ));

MultiModificationTrackingForm.propTypes = {
  model: PropTypes.shape({}),
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  onUpdate: PropTypes.func,
  schemas: PropTypes.arrayOf(PropTypes.shape({})),
};

export default MultiModificationTrackingForm;
